import { render, staticRenderFns } from "./ConceptCategory.vue?vue&type=template&id=2defabe0&scoped=true"
import script from "./ConceptCategory.vue?vue&type=script&lang=js"
export * from "./ConceptCategory.vue?vue&type=script&lang=js"
import style0 from "./ConceptCategory.vue?vue&type=style&index=0&id=2defabe0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2defabe0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2defabe0')) {
      api.createRecord('2defabe0', component.options)
    } else {
      api.reload('2defabe0', component.options)
    }
    module.hot.accept("./ConceptCategory.vue?vue&type=template&id=2defabe0&scoped=true", function () {
      api.rerender('2defabe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/ConceptCategory.vue"
export default component.exports